import * as React from "react";
import { forwardRef } from "react";
const SvgSatisfactionSurvey = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M16.9999 31.1666C24.824 31.1666 31.1666 24.824 31.1666 16.9999C31.1666 9.17588 24.824 2.83325 16.9999 2.83325C9.17588 2.83325 2.83325 9.17588 2.83325 16.9999C2.83325 24.824 9.17588 31.1666 16.9999 31.1666Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9.72046 19.1794C10.181 20.7535 11.1392 22.1359 12.4517 23.1193C13.7641 24.1028 15.3599 24.6344 16.9999 24.6344C18.64 24.6344 20.2358 24.1028 21.5482 23.1193C22.8606 22.1359 23.8189 20.7535 24.2794 19.1794",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11.0064 14.8205C11.9092 14.8205 12.6411 14.0887 12.6411 13.1859C12.6411 12.2831 11.9092 11.5513 11.0064 11.5513C10.1037 11.5513 9.37183 12.2831 9.37183 13.1859C9.37183 14.0887 10.1037 14.8205 11.0064 14.8205Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22.8846 14.8205C23.7874 14.8205 24.5192 14.0887 24.5192 13.1859C24.5192 12.2831 23.7874 11.5513 22.8846 11.5513C21.9818 11.5513 21.25 12.2831 21.25 13.1859C21.25 14.0887 21.9818 14.8205 22.8846 14.8205Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgSatisfactionSurvey);
export default ForwardRef;
